import api from '../../services/service_village'
import api2 from '../../services/service_line'
import Swal from 'sweetalert2'
import Pagination from 'vue-pagination-2'

export default {
  components: {
    Pagination
  },
  created() {
    this.checkUser()
  },
  data() {
    return {
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      ad_text: '',
      home_list: [],
      home_all: false,
      home_data: [],
      search: '',
      activePage: 1,
      allItem: 0,
      ItemPerpage: 10
    }
  },
  methods: {
    addHome() {
      this.activePage = 1
      this.searchVillage()
      $('#village').modal('show')
    },
    callback: function (page) {
      this.activePage = page
      this.searchVillage()
    },
    searchVillage() {
      var obj = {
        search: this.search,
        zone: 0,
        active_page: this.activePage,
        per_page: this.ItemPerpage
      }
      api.searchVillages(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.home_data = result.data.pagination
            this.allItem = result.data.count
          } else {
            Swal.fire('ดึงข้อมูลบ้าน', result.message, 'warning')
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    },
    addTolist(data) {
      var index = this.home_list.findIndex(x => x.home_id === data.home_id)
      if (index < 0) {
        this.home_list.push(data)
        this.home_all = false
        Swal.fire('เพิ่มบ้านเลขที่ต้องการส่ง', 'เพิ่มเข้ารายการที่ต้องการส่งเรียบร้อย', 'success')
      }
    },
    removeList(index) {
      this.home_list.splice(index, 1)
    },
    sendLine() {
      var obj = {
        text: this.ad_text,
        send_all: this.home_all,
        home_data: this.home_list
      }
      api2.sendLine(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            Swal.fire('ส่งข้อมูลประชาสัมพันธ์', result.message, 'success')
            this.ad_text = ''
            this.home_list = []
            this.home_all = false
          } else {
            Swal.fire('ดึงข้อมูลบ้าน', result.message, 'warning')
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/advertise.js